import React from 'react';
import { Line } from 'react-chartjs-2';
import { INBOUND_STRINGS, TREND_CHART_COLORS } from "../util/Constants";

const TrendChart = ({ trendData }) => {
    trendData = trendData || [];
    
    // Extract time labels and values
    const labels = trendData.map(function(point) {
        return (point && point.time) || '';
    });
    const actualValues = trendData.map(function(point) {
        return (point != null && point.actual != null) ? point.actual : 0;
    });

    const data = {
        labels: labels,
        datasets: [
            {
                label: INBOUND_STRINGS.ACTUAL_PPH,
                data: actualValues,
                borderColor: TREND_CHART_COLORS.LINE,
                backgroundColor: TREND_CHART_COLORS.LINE_FILL,
                borderWidth: 2,
                pointRadius: 4,
                pointBackgroundColor: TREND_CHART_COLORS.LINE,
                pointBorderColor: TREND_CHART_COLORS.POINT_BORDER,
                pointBorderWidth: 2,
                tension: 0.4,
                fill: false
            }
        ]
    };

    // Only treat as all-zero when we have data AND every value is truly 0
    const hasData = actualValues.length > 0;
    const allZero = hasData && actualValues.every(function(v) { return v === 0; });

    function buildYTicks(isAllZero) {
        var ticks = {
            beginAtZero: isAllZero,
            callback: function(value) {
                return value >= 1000
                    ? (value / 1000).toFixed(1) + 'k'
                    : value;
            },
            fontColor: TREND_CHART_COLORS.TICK_FONT,
            fontSize: 11,
            maxTicksLimit: 6
        };
        if (isAllZero) {
            ticks.min = 0;
            ticks.max = 10;
            ticks.stepSize = 5;
            ticks.maxTicksLimit = 4;
        }
        return ticks;
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            yAxes: [{
                ticks: buildYTicks(allZero),
                gridLines: {
                    color: TREND_CHART_COLORS.GRID_LINE,
                    drawBorder: false
                }
            }],
            xAxes: [{
                ticks: {
                    fontColor: TREND_CHART_COLORS.TICK_FONT,
                    fontSize: 11
                },
                gridLines: {
                    display: false
                }
            }]
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            backgroundColor: TREND_CHART_COLORS.TOOLTIP_BG,
            titleFontSize: 12,
            bodyFontSize: 12,
            callbacks: {
                title: function(tooltipItems) {
                    if (!tooltipItems || !tooltipItems[0]) {
                        return '';
                    }
                    var point = trendData[tooltipItems[0].index];
                    if (point && point.date) {
                        return point.date + ' ' + point.time;
                    }
                    return tooltipItems[0].xLabel || '';
                },
                label: function(tooltipItem, data) {
                    const label = data.datasets[tooltipItem.datasetIndex].label || '';
                    const value = Number(tooltipItem.yLabel).toFixed(1);
                    return label + ': ' + value + INBOUND_STRINGS.PPH_SUFFIX;
                }
            }
        },
        hover: {
            mode: 'index',
            intersect: false
        }
    };

    // Use max value as key so Chart.js fully remounts when scale changes
    const maxValue = hasData ? Math.max.apply(null, actualValues) : 0;

    return (
        <div className="trend-chart-wrapper">
            <Line key={maxValue} data={data} options={options} />
        </div>
    );
};

export default TrendChart;



// WEBPACK FOOTER //
// ./src/components/inbound/TrendChart.js